import { render, staticRenderFns } from "./CardTask.vue?vue&type=template&id=3949a556"
import script from "./CardTask.vue?vue&type=script&lang=js"
export * from "./CardTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports